export default __webpack_public_path__ + "static/media/About-us.6cb6d39f.png";